import { Navigate } from 'react-router-dom';
import { usePermisos } from '../context/PermisosContext';

export default function RutaConPermiso({ permiso, children }) {
  const { tienePermiso, cargando } = usePermisos();
  if (cargando) return <div className="p-6 text-gray-500">Cargando…</div>;
  if (!tienePermiso(permiso)) return <Navigate to="/" replace />;
  return children;
}